import { createSelector } from '@ngrx/store';
import { IRootState } from '../../../root';
import { IDisclosureState } from './disclosure.state';

export class DisclosureSelectors {
  // todo: replace any type state with root state (once defined)
  static readonly disclosureState = (state: IRootState): IDisclosureState => {
    return state.disclosure as IDisclosureState;
  };

  static readonly model = createSelector(DisclosureSelectors.disclosureState, (disclosure: IDisclosureState) => {
    return disclosure.model;
  });

  static readonly data = createSelector(DisclosureSelectors.disclosureState, (disclosure: IDisclosureState) => {
    return disclosure.data;
  });
}
